export default __webpack_public_path__ + "static/media/consumer.6b5c81a0.png";